// Paths list to update in the future
export const MAIN_PATHS = {
	HOME: '/'
};
